import { toDate } from 'date-fns';

class propagation {
    #config = {};
    #collection;
    #BATCH_SIZE = 100;
    #debug = () => { }
    constructor() {
    }

    registerCollection = (collection) => {
        cnsl(true, `Propagation collection registered: ${collection} | Batch Size: ${this.#BATCH_SIZE}`)
        this.#collection = collection;
    }

    enableDebugging = () => {
        this.#debug = (msg, error) => {
            if (error) return console.warn(msg);
            return console.log(msg);
        }
        cnsl(true, 'Debugging enabled');
    }

    /* Adds propagation configuration to class */
    registerConfig = (config) => {
        this.#config = config;
        cnsl(true, 'Propagation config registered');
    }

    requestPropagation = async (collection, id, user, deferred = true) => {
        // Create an object for this propagation request
        const propagationObject = {
            _id: null,
            active: true,
            collection,
            documentId: oid(id, false),
            addedTime: toDate(Date.now()),
            user
        }

        // Add the object to the collection
        await conn
            .collection(this.#collection)
            .insertOne(propagationObject);

        /* If deferred, let the requestor continue */
        if (deferred) {
            this.runPropagation(propagationObject);
            return propagationObject;
        }
        /* If not deferred, await the results */
        return this.runPropagation(propagationObject, true)
    }

    runPropagation = async (po, throwErrow = false) => {
        const startTime = new Date();

        const infos = [];
        const results = {};
        let success = true;

        // await new Promise((resolve) => setTimeout(() => resolve(), 200))

        /*  */
        const configs = this.#config[po.collection]
        if (!configs) {
            this.#debug(`No config defined for ${po.collection}`, true)
            return null;
        }

        for (const target in configs) {
            const config = configs[target];
            const document = await this.getRecord(po.collection, target, po.documentId, null);

            if (!document) continue;
            const info = await this.#updateDirect(target, config, document);
            if (!info.success) success = false;
            infos.push(info);
            results[info.collection] = info;
        }
        // console.log(results);
        const endTime = new Date();

        await conn
            .collection(this.#collection)
            .updateOne(
                { _id: po._id },
                {
                    $set: {
                        times: {
                            start: toDate(startTime),
                            end: toDate(endTime),
                            duration: endTime - startTime
                        },
                        success,
                        infos,
                        results
                    }
                }
            )
        if (!success && throwErrow) throw new Error('Propagation failed');
        return results;
    }

    getRecord = async (sourceCol, targetCol, id, customFilter) => {
        id = oid(id, false);
        const config = this.#config[sourceCol]?.[targetCol];
        let ignoreFields = config?.ignoreFields;
        let includeFields = config?.includeFields;
        let projection = {};
        if (ignoreFields && ignoreFields.length) {
            ignoreFields.forEach(item => {
                projection[item] = 0;
            })
        }
        if (includeFields && includeFields.length) {
            includeFields.forEach(item => {
                projection[item] = 1;
            })
            projection.active = 1;
        }

        /* Filter by _id is default */
        const filter = id ? { _id: id } : customFilter;
        if (!filter) return null;

        const document = await conn
            .collection(sourceCol)
            .findOne(filter, { projection });

        // console.log(projection);
        // console.log(document);
        if (!document) return null;
        return document.active ? document : { _id: document._id, active: false };
    }

    #updateDirect = async (target, config, document) => {
        const startTime = new Date();

        const info = {
            collection: target,
            batches: 0,
            matchedCount: 0,
            modifiedCount: 0,
            success: true,
            startTime: toDate(startTime),
            endTime: null
        }

        try {
            const cursor = conn
                .collection(target)
                .find({ [config.filter]: document._id }, { projection: { _id: 1 } })
                .batchSize(this.#BATCH_SIZE);

            while (await cursor.hasNext()) {
                const batch = [];
                while (await cursor.hasNext()) {
                    const _ = await cursor.next();
                    batch.push(_._id);
                    if (batch.length === this.#BATCH_SIZE) break;
                }
                if (!batch.length) continue;
                const arr = config.arrayFilter ? { arrayFilters: [{ [config.arrayFilter]: document._id }] } : {}
                const { matchedCount, modifiedCount } = await conn
                    .collection(target)
                    .updateMany(
                        { _id: { $in: batch } },
                        { $set: { [config.update]: document } },
                        { ...arr }
                    )
                info.matchedCount += matchedCount;
                info.modifiedCount += modifiedCount;
                info.batches += 1;
                // console.log(batch.length, matchedCount, modifiedCount)
            }
            const endTime = new Date();
            info.endTime = toDate(endTime);
            info.duration = endTime - startTime;
            return info;
        } catch (err) {
            info.success = false;
            info.error = err.message;
            return info;
        }
    }

    #updateArray = async () => {

    }

    getConfigs = () => {
        return this.#config;
    }
}
const propagationInstance = new propagation();
export default propagationInstance;

global._propagate = propagationInstance.requestPropagation;
global._embed = propagationInstance.getRecord;